import { defineNuxtPlugin, useRuntimeConfig } from "nuxt/app";

export default defineNuxtPlugin(() => {
  return {
    provide: {
      host: () => useRuntimeConfig().public.STATIC_HOST,
    }
  }
})
